<template>
  <div class="index outer bgblack" id="restaurantmodest">
    <div class="container-fluid" id="info">
      <div class="row padding215 align-items-center">
        <div
          id="restaurantmodest"
          class="col-md-10 offset-md-1 col-lg-6 offset-lg-0"
        >
          <h2>Restaurant Modest</h2>
        </div>
        <div class="col-md-10 offset-md-1 col-lg-5">
          <div class="negmargin">
            <p>{{ $t("home.modest.content") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Concept",
};
</script>
